export default __webpack_public_path__ + "static/media/clock.239efc2b.svg";